module.exports = __webpack_public_path__ + "img/logo-up.f043adfe.png";